import {AuthenticationType} from '@models/enums/authentication-type.enum';
import {UserBusinessType} from '@models/enums/user-business-type.enum';

export class JWTUser {
    userId: string;
    jti: string;
    iss: string;
    sub: string;
    given_name: string;
    boschId: string;
    role: string;
    permissions: string[] = [];
    sections?: string[];
    userBusinessType?: UserBusinessType;
    authenticationType?: AuthenticationType;
    exp: number;
    aud: string;

    static toUserBusinessType(value: UserBusinessType | string | number | null | undefined): UserBusinessType | undefined {
        if (value === null || value === undefined) {
            return undefined;
        }

        if (typeof value === 'number') {
            return UserBusinessType[value] !== undefined ? value : undefined;
        }

        const numericValue = Number(value);
        if (!Number.isNaN(numericValue) && UserBusinessType[numericValue] !== undefined) {
            return numericValue;
        }

        const enumValue = UserBusinessType[value as keyof typeof UserBusinessType];
        if (typeof enumValue === 'number') {
            return enumValue;
        }

        return undefined;
    }

    static toAuthenticationType(value: AuthenticationType | string | null | undefined): AuthenticationType | undefined {
        if (!value) {
            return undefined;
        }

        const normalizedValue = value.toString().toLowerCase();
        return Object.values(AuthenticationType).find(type => type.toLowerCase() === normalizedValue);
    }

    constructor(data?: Partial<JWTUser> & {
        userBusinessType?: UserBusinessType | string | number | null,
        authenticationType?: AuthenticationType | string | null
    }) {
        Object.assign(this, data);
        this.userBusinessType = JWTUser.toUserBusinessType(data?.userBusinessType);
        this.authenticationType = JWTUser.toAuthenticationType(data?.authenticationType);
    }
}
